import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../services/api';

const ParentChildContext = createContext();

export const useParentChild = () => {
  const ctx = useContext(ParentChildContext);
  if (!ctx) throw new Error('useParentChild must be used within ParentChildProvider');
  return ctx;
};

export const ParentChildProvider = ({ children }) => {
  const [childList, setChildList] = useState([]);
  const [selectedChild, setSelectedChild] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/parent-portal/children')
      .then((res) => {
        if (res.data.success && res.data.data?.length) {
          setChildList(res.data.data);
          const saved = localStorage.getItem('parent_selected_inscription');
          const found = saved
            ? res.data.data.find((c) => String(c.inscription_id) === saved)
            : null;
          setSelectedChild(found || res.data.data[0]);
        }
      })
      .finally(() => setLoading(false));
  }, []);

  const selectChild = (child) => {
    setSelectedChild(child);
    if (child?.inscription_id) {
      localStorage.setItem('parent_selected_inscription', String(child.inscription_id));
    }
  };

  return (
    <ParentChildContext.Provider value={{
      children: childList,
      selectedChild,
      selectChild,
      loading,
      inscriptionId: selectedChild?.inscription_id,
    }}>
      {children}
    </ParentChildContext.Provider>
  );
};
